/*******************************************************************************
* Project: J-SIPHE
* Summary:
*    Define Time Pipe
* History:
*    NguyenTV            2021/07/21    Create Date format pipe
******************************************************************************/
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'TimePipe' })
export class TimePipe implements PipeTransform {
    transform(pStrTime: string): string {
        try {
            if (pStrTime !== undefined && pStrTime != null && pStrTime !== '') {
                const HH = pStrTime.substring(0, 2);
                const mm = pStrTime.substring(2, 4);
                return HH + ':' + mm;
            } else {
                return '';
            }
        } catch (err) {
            return '';
        }
    }
}